export const setEventosActivos = (state,eventos) => {
  state.eventosActivos= eventos;
}